import { render } from "./drop-grupo-usuario.vue?vue&type=template&id=b750c64c"
import script from "./drop-grupo-usuario.js?vue&type=script&lang=js&external"
export * from "./drop-grupo-usuario.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__